// extracted by mini-css-extract-plugin
export default {"container":"Scroll_container__WBP2-","scroll":"Scroll_scroll__5JJk9","loop":"Scroll_loop__dkl5t","item":"Scroll_item__rZrew"};